module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "prect",
    attrs: {
      "id": "List"
    }
  }, [_c('a', {
    attrs: {
      "id": "pviii"
    }
  }), _c('a', {
    attrs: {
      "id": "pix"
    }
  }), _vm._v("List of Figures "), _c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "Zipes",
      "src": "images/ornament4.png"
    }
  })]), _vm._v(" "), _c('table', [_c('colgroup', [_c('col', {
    attrs: {
      "width": "80%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "20%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt1ch1.htm#fig1"
    }
  }, [_c('span', {
    staticClass: "toc1block"
  }, [_vm._v("1.")]), _vm._v("Eucrates and Pancrates")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt1ch1.htm#fig1"
    }
  }, [_vm._v("86")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt1ch1.htm#fig2"
    }
  }, [_c('span', {
    staticClass: "toc1block"
  }, [_vm._v("2.")]), _vm._v("The Story of the Brahmin Padmanaba and the Young Hassan")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt1ch1.htm#fig2"
    }
  }, [_vm._v("89")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt1ch2.htm#fig3"
    }
  }, [_c('span', {
    staticClass: "toc1block"
  }, [_vm._v("3.")]), _vm._v("The Master and His Pupil; or, The Magic Book")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt1ch2.htm#fig3"
    }
  }, [_vm._v("106")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt1ch3.htm#fig4"
    }
  }, [_c('span', {
    staticClass: "toc1block"
  }, [_vm._v("4.")]), _vm._v("The Rash Magician")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt1ch3.htm#fig4"
    }
  }, [_vm._v("118")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch1.htm#fig5"
    }
  }, [_c('span', {
    staticClass: "toc1block"
  }, [_vm._v("5.")]), _vm._v("Erysichthon and Mestra")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch1.htm#fig5"
    }
  }, [_vm._v("131")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch1.htm#fig6"
    }
  }, [_c('span', {
    staticClass: "toc1block"
  }, [_vm._v("6.")]), _vm._v("Maestro Lattantio and His Apprentice Dionigi")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch1.htm#fig6"
    }
  }, [_vm._v("145")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch2.htm#fig7"
    }
  }, [_c('span', {
    staticClass: "toc1block"
  }, [_vm._v("7.")]), _vm._v("The Nimble Thief and His Master")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch2.htm#fig7"
    }
  }, [_vm._v("164")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch2.htm#fig8"
    }
  }, [_c('span', {
    staticClass: "toc1block"
  }, [_vm._v("8.")]), _vm._v("The Magic Combat")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch2.htm#fig8"
    }
  }, [_vm._v("175")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch2.htm#fig9"
    }
  }, [_c('span', {
    staticClass: "toc1block"
  }, [_vm._v("9.")]), _vm._v("The Tuft of Wild Beet")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch2.htm#fig9"
    }
  }, [_vm._v("185")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch2.htm#fig10"
    }
  }, [_c('span', {
    staticClass: "toc1block"
  }, [_vm._v("10.")]), _vm._v("The Magician and His Servant")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch2.htm#fig10"
    }
  }, [_vm._v("194")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch3.htm#fig11"
    }
  }, [_c('span', {
    staticClass: "toc1block"
  }, [_vm._v("11.")]), _vm._v("The Twelfth Captain’s Tale")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch3.htm#fig11"
    }
  }, [_vm._v("248")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch3.htm#fig12"
    }
  }, [_c('span', {
    staticClass: "toc1block"
  }, [_vm._v("12.")]), _vm._v("The Black King of Morocco")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch3.htm#fig12"
    }
  }, [_vm._v("255")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch3.htm#fig13"
    }
  }, [_c('span', {
    staticClass: "toc1block"
  }, [_vm._v("13.")]), _vm._v("The Magician’s Heart")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch3.htm#fig13"
    }
  }, [_vm._v("261")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch3.htm#fig14"
    }
  }, [_c('span', {
    staticClass: "toc1block"
  }, [_vm._v("14.")]), _vm._v("The Forest Dweller")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch3.htm#fig14"
    }
  }, [_vm._v("275")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch3.htm#fig15"
    }
  }, [_c('span', {
    staticClass: "toc1block"
  }, [_vm._v("15.")]), _vm._v("The Mistress of Magic")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch3.htm#fig15"
    }
  }, [_vm._v("297")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch3.htm#fig16"
    }
  }, [_c('span', {
    staticClass: "toc1block"
  }, [_vm._v("16.")]), _vm._v("The Magician and His Disciple")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt2ch3.htm#fig16"
    }
  }, [_vm._v("315")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt3.htm#fig17"
    }
  }, [_c('span', {
    staticClass: "toc1block"
  }, [_vm._v("17.")]), _vm._v("Krabat: A Legend from Folklore")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt3.htm#fig17"
    }
  }, [_vm._v("325")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt3.htm#fig18"
    }
  }, [_c('span', {
    staticClass: "toc1block"
  }, [_vm._v("18.")]), _vm._v("Krabat (1865)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt3.htm#fig18"
    }
  }, [_vm._v("327")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt3.htm#fig19"
    }
  }, [_c('span', {
    staticClass: "toc1block"
  }, [_vm._v("19.")]), _vm._v("The Wendish Faust Legend")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt3.htm#fig19"
    }
  }, [_vm._v("336")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/pt3.htm#fig20"
    }
  }, [_c('span', {
    staticClass: "toc1block"
  }, [_vm._v("20.")]), _vm._v("Krabat (1959)")])])]), _vm._v(" "), _c('td', {
    staticClass: "no-rule"
  }, [_c('p', {
    staticClass: "page"
  }, [_c('a', {
    attrs: {
      "href": "#/pt3.htm#fig20"
    }
  }, [_vm._v("345")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4770eb75","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/list.vue
// module id = 72
// module chunks = 0